// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"2ce3f76f","867":"9ba47be8"}[chunkId] + ".chunk.js";
};